import { render, staticRenderFns } from "./TLocationRoaming.vue?vue&type=template&id=15af83d7&"
import script from "./TLocationRoaming.vue?vue&type=script&lang=js&"
export * from "./TLocationRoaming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports